import RelationshipMetadata from "../../RelationshipMetadata";

class AdminRoleAdminRoleViewRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "AdminRoleAdminRoleViewRelationshipMetadata";
        this.parentEnterpriseComponent = "AdminRole";
        this.childEnterpriseComponent = "AdminRoleView";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "RoleUSID";
    }
}

export default AdminRoleAdminRoleViewRelationshipMetadata;